import { memoize } from '../cache/memoize';

export const getIntlDisplayNameFormat = memoize(function getIntlDisplayNameFormat(...args: ConstructorParameters<typeof Intl.DisplayNames>) {
  return new Intl.DisplayNames(...args);
});
